// Modul zur Anzeige des Standard-Zuschusses
"use strict";

import module from "./module.js";

export default module;
